import { addSnackMessage } from '@greenkub-fronts/domain/snackbar';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  CALL_FOR_CAPITAL_TYPE,
  GenerateCallForCapitalData,
} from '@greenkub-fronts/shared/interface';

export const generateCallForCapitalDocument = createAsyncThunk(
  'generateCallForCapitalDocument',
  async (
    data: GenerateCallForCapitalData,
    { dispatch, extra }: { dispatch: any; extra: any; getState: any }
  ) => {
    let nomDocument = 'Appel de fonds';

    switch (data.type) {
      case CALL_FOR_CAPITAL_TYPE.ADF_1:
        nomDocument += ' 10% DG';
        break;
      case CALL_FOR_CAPITAL_TYPE.ADF_2:
        nomDocument += ' 40% AM';
        break;
      case CALL_FOR_CAPITAL_TYPE.ADF_3:
        nomDocument += ' 40% EXP';
        break;
      case CALL_FOR_CAPITAL_TYPE.ADF_4:
        nomDocument += ' 10% SOLDE';
        break;
    }

    dispatch(
      addSnackMessage('positive', nomDocument + ' en cours de génération')
    );

    const result = await dispatch(
      extra.apiSlice.endpoints.generateFile.initiate({
        projectId: data.projectId,
        standardSlug: data.type,
        data: {
          amount: data.amount,
          customer: {
            fullName: data.fullName,
            company: data.company,
            street: data.street,
            postalCode: data.postalCode,
            email: data.email,
            phone: data.phone,
            city: data.city,
          },
        },
      })
    );

    if (result.data.message) {
      dispatch(addSnackMessage('negative', result.data.message));
      return;
    }
  }
);

export default generateCallForCapitalDocument;
